import React, { ReactNode } from 'react'

type FlatButtonProps = {
  children: ReactNode
  className?: string
  type?: 'button' | 'submit' | 'reset'
  outline?: boolean
  disabled?: boolean
  onClick?: (e: React.MouseEvent) => void
}

const FlatButton: React.FC<FlatButtonProps> = ({
  children,
  onClick,
  className,
  outline = false,
  type = 'button',
  disabled = false,
}) => {
  const defaultClassName = `block py-2 px-4 text-center font-bold h-fit transition-opacity duration-300 rounded-md`

  const colorClassName = outline
    ? 'bg-white text-main-green border border-main-green border'
    : 'bg-main-green text-white'

  const disabledClassName = disabled 
    ? 'opacity-50 cursor-not-allowed' 
    : 'hover:opacity-50'

  const combinedClassName = `${defaultClassName} ${colorClassName} ${disabledClassName} ${className ?? ''}`

  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={combinedClassName}
    >
      {children}
    </button>
  )
}

export default FlatButton
